import React from "react";

import { PenScanningCardsView } from "components/ScanningPenCards";

import { PenTypes } from "constants/auctionPens";

export const PenScanningView = () => (
  <PenScanningCardsView penType={PenTypes.SELLING} />
);
